import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Ordina prodotti stampati',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Dettagli prodotto',
    [ProductOrderingSteps.ShippingInfo]: 'Info spedizione',
    payment: 'Pagamento',
  },
  form: {
    title: 'Dettagli ordine',
    polygraphy_product_id: {
      label: 'Prodotto',
      placeholder: 'Seleziona prodotto',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Volantino - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Modello #1 🆕',
            [FlyerTemplate.Two]: 'Modello #2 🆕',
            [FlyerTemplate.Three]: 'Modello #3',
            [FlyerTemplate.Four]: 'Modello #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Adesivo - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Modello #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Adesivo porta - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Modello #1 🆕',
            [DoorStickerTemplate.Two]: 'Modello #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Quantità',
      placeholder: 'Inserisci quantità',
    },
    service_level: {
      label: 'Livello di servizio',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Economico',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Azienda',
      placeholder: 'Inserisci nome azienda',
    },
    shipping_salutation: {
      label: 'Titolo',
      options: {
        mr: 'Sig.',
        mrs: 'Sig.ra',
      },
    },
    shipping_first_name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome',
    },
    shipping_last_name: {
      label: 'Cognome',
      placeholder: 'Inserisci il cognome',
    },
    shipping_country: {
      label: 'Paese',
      placeholder: 'Seleziona paese',
    },
    shipping_state: {
      label: 'Stato',
      placeholder: 'Seleziona stato',
    },
    shipping_city: {
      label: 'Città',
      placeholder: 'Inserisci la città',
    },
    shipping_address: {
      label: 'Indirizzo',
      placeholder: "Inserisci l'indirizzo",
    },
    shipping_zip_code: {
      label: 'CAP',
      placeholder: 'Inserisci il CAP',
    },
    shipping_phone_number: {
      label: 'Numero di telefono',
      placeholder: 'Inserisci il numero di telefono',
    },
    create_invoice: {
      options: {
        true: 'Addebito automatico - Pagamento immediato',
        false: 'Invia gratuitamente - È un regalo',
      },
    },
  },
  table: {
    title: 'Ordini precedenti',
    fields: {
      product: 'Prodotto',
      quantity: 'Quantità',
      status: 'Stato',
      service_level: 'Livello di servizio',
      shipping: 'Spedizione',
      tracking_url: 'URL di tracciamento',
      created: 'Creato',
      updated: 'Ultimo aggiornamento',
    },
  },
  labels: {
    shipping_company: 'Azienda',
    shipping_salutation: 'Titolo',
    shipping_first_name: 'Nome',
    shipping_last_name: 'Cognome',
    shipping_address: 'Indirizzo',
    shipping_zip_code: 'CAP',
    shipping_city: 'Città',
    shipping_phone_number: 'Numero di telefono',
    show_shipping_details: 'Dettagli spedizione',
    track_order: 'Traccia ordine',
    pending_from_provider: 'In attesa dal fornitore',
  },
  modals: {
    confirmation: {
      title: 'Conferma dettagli ordine',
    },
    free_order_confirmation: {
      title: 'Sei sicuro di voler inviare {{product}} gratuitamente?',
      description: 'Hai scelto di non addebitare nulla al cliente oggi.\n Il prodotto verrà spedito senza pagamento.',
      buttons: {
        confirm: 'Sì, invia gratuitamente',
      },
    },
  },
  buttons: {
    back_to_templates: 'Torna ai modelli',
    preview: 'Anteprima',
    next: 'Avanti',
    order: 'Crea ordine',
    confirm: 'Conferma',
  },
  feedback: {
    shop_url_used: "Il prodotto include l'URL del negozio online (<url>{{url}}</url>). È intenzionale?",
    order_total_price: 'Prezzo totale per i prodotti selezionati: <strong>{{amount}} NETTO</strong>',
  },
  toasts: {
    failed_to_create_order: "Creazione dell'ordine non riuscita",
    order_got_created: 'Ordine creato',
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
